
// 1.

// import { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";
// import "./BusinessGroupListUpdate.css";
// import { AppThemeContext } from "../../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { Business } from "@mui/icons-material";

// function BusinessGroupListUpdate({ show, handleClose, userData, handleUpdate }) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [formData, setFormData] = useState({
//         userId: "",
//         userName: "",
//         address: "",
//         email: "",
//         password: "",

//     });

//     const User_ID=sessionStorage.getItem("LOGIN_ID");

//     useEffect(() => {
//         if (userData) {
//             setFormData({
//                 userId: userData.Group_id || "",
//                 userName: userData.CompanyName || "",
//                 address: userData.Address || "",
//                 email: userData.Email || "",
//                 password: userData.Password || "",

//             });
//         }
//     }, [userData]);


//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.userId) {
//             console.error("User ID is missing. Cannot update.");
//             return;
//         }

//         try {
//             const queryParams = new URLSearchParams({
//                 Group_Name: formData.userName,
//                 Address: formData. address,
//                 Mail_ID: formData.email,
//                 Password: formData.password,
//                 SKey: "XYZ"
//             }).toString();

//             const formBody = new URLSearchParams({
//                 USER_ID: User_ID,
//                 Group_ID:formData.userId,
//                 TYPE_ID:"U"
//             }).toString();

//             const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
//             console.log("API URL:", finalUrl);

//             const response = await fetch(finalUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded",
//                 },
//                 body: formBody,
//             });

//             console.log("API Response:", response);

//             if (!response.ok) {
//                 throw new Error("Failed to update user");
//             }

//             const rawResponse = await response.text();
//             console.log("Raw API Response:", rawResponse);

//             const result = JSON.parse(rawResponse);
//             console.log("API Response Data:", result);

//             if (result.success) {
//                 handleUpdate(result); // Notify parent component
//                 handleClose(); // Close modal
//             }
//         } catch (error) {
//             console.error("Error updating user:", error);
//         }
//     };
//     return (

//         <>
//           <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                 <Modal.Title>Update User Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form onSubmit={handleSubmit}>
//                     <div className="row">
//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>User ID</Form.Label>
//                                 <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
//                             </Form.Group>
//                         </div>



//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>User Name</Form.Label>
//                                 <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
//                             </Form.Group>
//                         </div>


//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Address</Form.Label>
//                                 <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
//                             </Form.Group>
//                         </div>


//                         {/* <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Email</Form.Label>
//                                 <Form.Control type="text" name="email" value={formData.email} onChange={handleChange} />
//                             </Form.Group>
//                         </div> */}

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Email</Form.Label>
//                                 <Form.Control
//                                     as="textarea"
//                                     name="email"
//                                     value={formData.email}
//                                     onChange={handleChange}
//                                     style={{
//                                         minHeight: '80px',
//                                         width: '100%',
//                                         overflow: 'auto',
//                                         whiteSpace: 'normal',
//                                         wordWrap: 'break-word',
//                                         resize: 'vertical',
//                                         fontSize: '14px', // optional: improves appearance
//                                         padding: '10px'   // optional: for better spacing
//                                     }}
//                                 />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Password</Form.Label>
//                                 <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
//                             </Form.Group>
//                         </div>


//                     </div>

//                     <Modal.Footer>
//                         <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
//                             Cancel
//                         </Button>
//                         <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
//                             Update
//                         </Button>
//                     </Modal.Footer>
//                 </Form>
//             </Modal.Body>
//         </Modal> 
//         </>



//     );
// }

// export default BusinessGroupListUpdate;

// 2.

// import { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";
// import "./BusinessGroupListUpdate.css";
// import { AppThemeContext } from "../../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { Business } from "@mui/icons-material";

// function BusinessGroupListUpdate({ show, handleClose, userData, handleUpdate }) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [formData, setFormData] = useState({
//         userId: "",
//         userName: "",
//         address: "",
//         email: "",
//         password: "",

//     });

//     const User_ID = sessionStorage.getItem("LOGIN_ID");

//     useEffect(() => {
//         if (userData) {
//             setFormData({
//                 userId: userData.Group_id || "",
//                 userName: userData.CompanyName || "",
//                 address: userData.Address || "",
//                 email: userData.Email || "",
//                 password: userData.Password || "",

//             });
//         }
//     }, [userData]);


//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.userId) {
//             alert("User ID is missing. Cannot update.");
//             return;
//         }

//         try {
//             const queryParams = new URLSearchParams({
//                 Group_Name: formData.userName,
//                 Address: formData.address,
//                 Mail_ID: formData.email,
//                 Password: formData.password,
//                 SKey: "XYZ"
//             }).toString();

//             const formBody = new URLSearchParams({
//                 USER_ID: User_ID,
//                 Group_ID: formData.userId,
//                 TYPE_ID: "U"
//             }).toString();

//             const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;

//             const response = await fetch(finalUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded",
//                 },
//                 body: formBody,
//             });

//             if (!response.ok) {
//                 throw new Error("Failed to update user");
//             }

//             const rawResponse = await response.text();
//             const result = JSON.parse(rawResponse);

//             // अपडेट सफलता चेक
//             if (result.success || result.responseCode === "200") {
//                 // 1. अलर्ट मैसेज
//                 alert("Business Group successfully updated!");

//                 // 2. Parent component को अपडेट करें और modal बंद करें
//                 handleUpdate(result);
//                 handleClose();
//             } else {
//                 alert("Failed to update Business Group!");
//             }
//         } catch (error) {
//             console.error("Error updating user:", error);
//             alert("Network Error! Please try again.");
//         }
//     };
//     return (

//         <>
//             <Modal show={show} onHide={handleClose} centered>
//                 <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                     <Modal.Title>Update User Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Form onSubmit={handleSubmit}>
//                         <div className="row">
//                             <div className="col-md-12">
//                                 <Form.Group className="mb-1">
//                                     <Form.Label>User ID</Form.Label>
//                                     <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
//                                 </Form.Group>
//                             </div>



//                             <div className="col-md-12">
//                                 <Form.Group className="mb-1">
//                                     <Form.Label>User Name</Form.Label>
//                                     <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                             <div className="col-md-12">
//                                 <Form.Group className="mb-1">
//                                     <Form.Label>Address</Form.Label>
//                                     <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                             {/* <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Email</Form.Label>
//                                 <Form.Control type="text" name="email" value={formData.email} onChange={handleChange} />
//                             </Form.Group>
//                         </div> */}

//                             <div className="col-md-12">
//                                 <Form.Group className="mb-1">
//                                     <Form.Label>Email</Form.Label>
//                                     <Form.Control
//                                         as="textarea"
//                                         name="email"
//                                         value={formData.email}
//                                         onChange={handleChange}
//                                         style={{
//                                             minHeight: '80px',
//                                             width: '100%',
//                                             overflow: 'auto',
//                                             whiteSpace: 'normal',
//                                             wordWrap: 'break-word',
//                                             resize: 'vertical',
//                                             fontSize: '14px', // optional: improves appearance
//                                             padding: '10px'   // optional: for better spacing
//                                         }}
//                                     />
//                                 </Form.Group>
//                             </div>

//                             <div className="col-md-12">
//                                 <Form.Group className="mb-1">
//                                     <Form.Label>Password</Form.Label>
//                                     <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                         </div>

//                         <Modal.Footer>
//                             <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
//                                 Cancel
//                             </Button>
//                             <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
//                                 Update
//                             </Button>
//                         </Modal.Footer>
//                     </Form>
//                 </Modal.Body>
//             </Modal>
//         </>



//     );
// }

// export default BusinessGroupListUpdate;

// 3.

import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./BusinessGroupListUpdate.css";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../../../api/AxiosApi";

function BusinessGroupListUpdate({ show, handleClose, userData, handleUpdate }) {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [formData, setFormData] = useState({
        userId: "",
        userName: "",
        address: "",
        email: "",
        password: "",
    });

    const User_ID = localStorage.getItem("business_LOGIN_ID") || "";

    useEffect(() => {
        if (userData) {
            setFormData({
                userId: userData.Group_id || "",
                userName: userData.CompanyName || "",
                address: userData.Address || "",
                email: userData.Email || "",
                password: userData.Password || "",
            });
        }
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.userId) {
            alert("User ID is missing. Cannot update.");
            return;
        }

        try {
            const queryParams = new URLSearchParams({
                Group_Name: formData.userName || "-",
                Address: formData.address || "-",
                Mail_ID: formData.email || "-",
                Password: formData.password || "-",
                SKey: "XYZ"
            }).toString();

            const formBody = new URLSearchParams({
                USER_ID: User_ID,
                Group_ID: formData.userId,
                TYPE_ID: "U"
            }).toString();

            const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;

            const response = await fetch(finalUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formBody,
            });

            if (!response.ok) {
                alert("Failed to update Business Group!");
                return;
            }

            const rawResponse = await response.text();
            
            // JSON parsing ko try-catch se secure kiya gaya hai
            let result;
            try {
                result = JSON.parse(rawResponse);
            } catch (jsonErr) {
                console.error("JSON Parse Error:", jsonErr);
            }

            // Flexibly check for success (string or boolean)
            const isSuccess = result && (
                result.success === true || 
                result.success === "true" || 
                result.responseCode === "200" ||
                result.data === "1"
            );

            if (isSuccess) {
                alert("Business Group successfully updated!");
                
                // Alert OK hone ke baad safe update call
                if (typeof handleUpdate === "function") {
                    handleUpdate(result);
                }
                handleClose();
            } else {
                alert("Failed to update Business Group!");
            }

        } catch (error) {
            console.error("Error updating user:", error);
            alert("Network Error! Please try again.");
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Update User Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>User ID</Form.Label>
                                <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>User Name</Form.Label>
                                <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Address</Form.Label>
                                <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    style={{
                                        minHeight: '80px',
                                        width: '100%',
                                        overflow: 'auto',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        resize: 'vertical',
                                        fontSize: '14px',
                                        padding: '10px'
                                    }}
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
                            </Form.Group>
                        </div>
                    </div>

                    <Modal.Footer>
                        <Button type="button" onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
                            Cancel
                        </Button>
                        <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default BusinessGroupListUpdate;